import { render, staticRenderFns } from "./PlaguesTracking.vue?vue&type=template&id=0b453217&scoped=true&lang=html&"
import script from "./PlaguesTracking.vue?vue&type=script&lang=js&"
export * from "./PlaguesTracking.vue?vue&type=script&lang=js&"
import style0 from "./PlaguesTracking.vue?vue&type=style&index=0&id=0b453217&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b453217",
  null
  
)

export default component.exports